export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/lyric_music_videos.5ff39a3.svg";